// export const API_URL = "https://demo-bot-functions-app.azurewebsites.net/api/";
export const API_URL = "https://worx-assistant-function-app.azurewebsites.net/api/"
